import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Badge = styled.span<{ $isSent: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;

  padding: 0.2rem 1rem;
  border-radius: 1.2rem;

  font-size: 1.2rem;
  line-height: 2rem;
  white-space: nowrap;

  color: ${({ $isSent }) => ($isSent ? pickColor('greenDark') : pickColor('grayLabel'))};
  background-color: ${({ $isSent }) => ($isSent ? '#eaf6e3' : '#f0f0f0')};
`;

export { Badge };
